import { ALLOWED_DASHBOARD_HOSTS } from '~/lib/databricks/consts';
import type {
  DashboardEmbedConfig,
  DashboardLinkResponse,
} from '~/lib/databricks/types';

function parseDashboardUrl(dashboardUrl: string):
  | {
      workspaceUrl: string;
      workspaceId: string;
      dashboardId: string;
    }
  | undefined {
  try {
    const parsed = new URL(dashboardUrl);

    if (
      parsed.protocol !== 'https:' ||
      !ALLOWED_DASHBOARD_HOSTS.includes(parsed.hostname)
    ) {
      return undefined;
    }

    // Extract dashboard ID
    const pathMatch = /\/dashboardsv3\/([^/]+)/.exec(parsed.pathname);
    const dashboardId = pathMatch?.[1];

    // Extract workspace ID
    const workspaceId = parsed.searchParams.get('o');

    if (!dashboardId || !workspaceId) {
      return undefined;
    }

    return {
      workspaceUrl: parsed.origin,
      workspaceId,
      dashboardId,
    };
  } catch {
    return undefined;
  }
}

export async function getDatabricksDashboardLink(
  apiUrl: string,
): Promise<DashboardEmbedConfig | undefined> {
  const response = await fetch(apiUrl);

  if (!response.ok) {
    return undefined;
  }

  const data: DashboardLinkResponse = await response.json();

  const parsedUrl = parseDashboardUrl(data.dashboard_url);

  if (!parsedUrl) {
    return undefined;
  }

  let expiresAt = data.expires_at ? new Date(data.expires_at) : undefined;

  if (expiresAt && !Number.isFinite(expiresAt.getTime())) {
    expiresAt = undefined;
  }

  return {
    workspaceUrl: parsedUrl.workspaceUrl,
    workspaceId: parsedUrl.workspaceId,
    dashboardId: parsedUrl.dashboardId,
    embedToken: data.dbx_token,
    expiresAt,
  };
}
